import { EXTERNAL_ROUTES } from '../constants/urls';

type LeadsPageListing = {
  isFeed?: boolean;
};

// Lead Management only resolves manual listings; the backend owns that rule, so derive it in this one place only.
export const getIsLeadManagementSupported = (listing: LeadsPageListing | undefined): boolean => !listing?.isFeed;

export const getLeadsPagePath = (listingAlias: string, listing: LeadsPageListing | undefined): string => {
  const basePath = getIsLeadManagementSupported(listing) ? EXTERNAL_ROUTES.LEAD_MANAGEMENT : EXTERNAL_ROUTES.CONTACTS;

  return `${basePath}/${listingAlias}`;
};
